<template>
      <div class="publicViewClass app-inner" style="padding-top:0">
        <div class="public-btn-small flex align-cen posta enposta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="reback">
            返回
            </div>
            </div>
            <div class="exam-title flex align-cen">
              <div class="exam-title-info flex align-cen">
                <b>{{paperInfo.paperName}}</b>
                <span class="title-extra" style="padding-left:10px">
                   | 考试时间：限制{{pageInfo.timeLimit}}分钟
                </span>
              </div>
              <!--  -->
                <div class="public-de flex align-cen" @click="deletTopic(multipleSelection)" v-if="isActive == 0 || isActive == 1">
                <span class="icon-al-delete"></span>
                <p>删除所选</p>
              </div>
            </div>
            <div class="exam-content">
                <div class="content-title flex align-cen">
                    <div class="all-takens">
                        <div class="nav nav-tabs">
                             <el-radio-group v-model="radio" @change="getResultListType(radio,true)">
                                <el-radio-button label="1">已考完 <span class="blue">{{pageInfo.examinedNum}}</span></el-radio-button>
                                <el-radio-button label="0" >未考完 <span class="yellwo">{{pageInfo.examiningNum}}</span></el-radio-button>
                                <el-radio-button label="2">缺考</el-radio-button>
                                <el-radio-button label="3">排行榜</el-radio-button>
                                </el-radio-group>
                        </div>
                    </div>
                </div>
                 <div class="p-tit-c" style="margin-top:20px" v-if="isActive == 0 || isActive == 1">
                <div class="businessList-filter">
                    <div class="businessList-filter-list flex align-cen">
                  <div class="fl-le flex align-cen">
                <div class="label">姓名：</div>
                <div class="el-select1">
                  <el-input placeholder="请输入交卷姓名" v-model="search" clearable> </el-input>
                </div>
              </div>
                  <div class="fl-rt flex align-cen">
                <div class="label">手机号：</div>
                <div class="el-select1">
                <el-input placeholder="请输入交卷人手机号" v-model="search1" clearable> </el-input>
                </div>
              </div>
                  </div>
                </div>
                     <div class="businessList-filter-list flex align-cen" style="margin-top:20px" v-if="isActive !=0">
                          <div class="label">考试时间：</div>
                          <div
                            style="color: red; padding-right: 20px; cursor: pointer"
                             @click="allradio"
                          >
                            不限
                          </div>
                          <el-radio v-model="searcradio" label="1" @change="classSelect">通过</el-radio>
                          <el-radio v-model="searcradio" label="0" @change="classSelect">未通过</el-radio>
                           <el-radio v-model="searcradio" label="2" @change="classSelect">未批卷</el-radio>
                        </div>
                               <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
                            <div class="label">考试时间：</div>
                            <el-date-picker
                              v-model="search3"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始时间"
                              end-placeholder="结束时间"
                              format="yyyy-MM-dd HH:mm:ss"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              :picker-options="pickerOptions2"
                              @change="classSelect"
                            >
                            </el-date-picker>
                          </div>
                            <div class="businessList-filter-list flex align-cen public-btn-small" style="margin-top:20px">
                                  <div class="public-btn-small-primary" @click="classSelect">
                                  搜索
                                  </div>
                                  <div class="public-btn-small-plan"  @click="exportExcel1(multipleSelection)">
                                    导出
                                  </div>
                                  <div class="public-btn-small-text" @click="reset">
                                  重置筛选条件
                                  </div>
                                </div>
                 </div>
                <div class="tabbable-custom">
                     <div class="rdsdiv"></div>
                      <div class="businessList-container-table" style="margin-top:16px" v-if="isActive == 0 || isActive == 1">
                         <el-table
                            ref="multipleTable"
                            :data="list"
                            tooltip-effect="dark"
                            style="width: 100%"
                            border
                            id='mytable'
                            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                            :row-key="getRowKeyOfTarget"
                             @selection-change="handleSelectionChange"
                            :key="120828"
                            >
                  <el-table-column type="selection" width="55" reserve-selection align="center" fixed="left"> </el-table-column>
                    <el-table-column  label="序号" align="center" width="55">
                        <template slot-scope="scope">
                        <div>{{scope.$index + 1}}</div>
                        </template>
                    </el-table-column>
                       <el-table-column prop="examiner" label="姓名" align="center">
                        </el-table-column>
                                  <el-table-column prop="businessName" label="所属企业" align="center" width="250">
          </el-table-column>
          <el-table-column  label="答题进度" align="center" v-if="isActive == 0">
           <template slot-scope="scope">
              <div   v-if="isActive == 0">{{scope.row.answerCount}}/{{scope.row.questionCount}}</div>
            </template>
          </el-table-column>
            <el-table-column prop="userScore" label="得分" align="center" v-if="isActive == 1">
                 <template slot-scope="scope">
                 <div  v-if="isActive == 1">
                    <span  v-if="scope.row.result !=2">{{String(scope.row.userScore)}}</span>
                     <span  v-else>-</span>
                    </div> 
                 </template>
          </el-table-column>
           <el-table-column  label="得分比" align="center" v-if="isActive == 1">
             <template slot-scope="scope">
            <div  v-if="isActive == 1">{{scope.row.scoreRate || '0.00'}}%</div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="考试时间" align="center" v-if="isActive == 1">
             <template slot-scope="scope">
              <div  v-if="isActive == 1">{{scope.row.startTime}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="createBy" label="用时" align="center" v-if="isActive == 1">
             <template slot-scope="scope">
              <div  v-if="isActive == 1">{{$util.convertSecondsToMinutes(scope.row.doTime,1)}}</div>
            </template>
          </el-table-column>
          <el-table-column  label="进入考试时间" align="center" v-if="isActive == 0">
             <template slot-scope="scope">
              <div  v-if="isActive == 0">{{scope.row.startTime}}</div>
            </template>
          </el-table-column>
          <el-table-column  label="IP" align="center" v-if="isActive == 0">
            <template slot-scope="scope">
              <div  v-if="isActive == 0">{{scope.row.ip}}</div>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="200"
            >
             <template slot-scope="scope">
                 <el-button type="text" size="small"  slot="reference" style="color:red" v-if="isActive == 0" @click.stop="subqz(scope.row)">强制交卷</el-button>
                 <el-button type="text" size="small"  slot="reference" style="color:red"  @click.stop="openTimline(scope.row)" v-if="isActive == 0">监控</el-button>
              <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="getResulttRanscript(scope.row)" v-if="isActive == 1 && scope.row.result !=2">成绩单</el-button>
                <el-button type="text" size="small"  slot="reference" style="color:red"  @click.stop="getResulttRanscript(scope.row)" v-if="isActive == 1 && scope.row.result ==2">查看</el-button>
                 <el-button type="text" size="small"  slot="reference" style="color:red"   @click.stop="getGradingPaper(scope.row)" v-if="isActive == 1 && scope.row.result ==2">批卷</el-button>
                 <!-- <el-button type="text" size="small"  slot="reference" style="color:red" v-if="isActive == 1">学员详情</el-button>  -->
            </template>
          </el-table-column> 
                         </el-table>
                          <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
                      </div>
                       <div class="businessList-container-table" style="margin-top:16px" v-if="isActive == 2">
                      <el-table
          ref="multipleTable1"
          :data="list1"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable1'
        :key="120828777"
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
        >
             <el-table-column  label="序号" align="center" width="55">
            <template slot-scope="scope">
              <div>{{scope.$index + 1}}</div>
            </template>
          </el-table-column>
             <el-table-column prop="userName" label="姓名" align="center">
          </el-table-column>
              <el-table-column prop="loginName" label="手机号码" align="center">
            </el-table-column>
                  <el-table-column  label="学员分类" align="center">
                      <template slot-scope="scope">
                        <div class="flex align-cen" style="justify-content:center" v-if="scope.row.traineeClassifyRelationList && scope.row.traineeClassifyRelationList.length">
                      <div v-for="(item,index) in scope.row.traineeClassifyRelationList"  class="tagbq">
                            {{item.classifyName}}
                        </div>
                        </div>
                        <div v-else>-</div>
                    </template>
            </el-table-column>
                      </el-table>
                       <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
             </div>
               <div class="businessList-container-table" style="margin-top:16px" v-if="isActive == 3">
                  <div class="rank-box">
                    <div class="ranks-title">
                      <div class="exams-tit">
                        《{{paperInfo.paperName}}》试卷排行榜
                      </div>
                      <div class="ranks-title-btn" @click="exportExcel(list2)">
                        导出
                      </div>
                    </div>
                    <div class="ranks-list">
                      <div class="rank flex align-cen" v-for="(item,index) in list2">
                         <div class="rank_num">
                           <img :src="getStatu(index,1)" alt="" v-if="index<3 && currentPage == 1" class="rank-img">
                           <span v-else>{{index + 1}}</span>
                         </div>
                         <div class="strImg" :style="randomFun()">
                          {{item.examiner.charAt(0)}}
                         </div>
                         <div class="info">
                          <div class="name">{{item.examiner}}</div>
                          <div class="time">用时：{{$util.convertSecondsToMinutes(item.doTime,1)}}</div>
                         </div>
                         <div class="count mft">{{item.userScore}}分</div>
                      </div>
                    </div>
                      <paginaTion :total="totalCount" @sendStatus="emitFun" class="ranklistPag"></paginaTion>
                  </div>
               </div>
                </div>
            </div>
                <!-- 查看成绩单 -->
      <el-dialog
  title="查看成绩单"
  :visible.sync="centerDialogVisible"
  width="40%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass paperDialogClass"
  v-if="centerDialogVisible && isActive == 1"
  >
    <el-tabs  v-model="activeName">
        <el-tab-pane label="本次成绩" name="1">
            <div class="print-tab-content">
                <div class="tester-info">
                    <p class="text">{{testerInfo.paperName}}</p>
                    <p class="text">考试者：{{testerInfo.examiner}}</p>
                    <p class="lastP">
                        开始时间：{{testerInfo.startTime}} | 交卷时间：{{testerInfo.answerTime}} 
                    </p>
                      <div class="sorceRow">
                         <div class="result-scores">
                            <div class="exam-record-info" v-if="testerInfo.result !=2">
                                <p class="score-num">{{testerInfo.userScore}}
                                    <span>分</span>
                                </p>
                            </div>
                            <div class="zf"  v-if="testerInfo.result !=2">(总分{{testerInfo.paperScore}}分)</div>
                            <div class="reult2" v-if="testerInfo.result ==2">
                                <div class="reult2_tip">答题已结束，感谢您的参加</div>
                                <div class="reult2_pj">请等待老师批卷，批卷完成后将展示成绩</div>
                            </div>
                             <div class="zf">用时：{{$util.convertSecondsToMinutes(testerInfo.doTime,2)}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="答题分析" name="2">
             <div>
    <el-radio-group v-model="radio" @change="getQuestionListCom(radio)">
      <el-radio-button label="1">
        答对（{{testerInfo.rightNum}}）
      </el-radio-button>
           <el-radio-button label="5" v-if="testerInfo.result == 2">
        未批改（{{testerInfo.uncorrectedNum}}）
      </el-radio-button>
      <el-radio-button label="2">
        答错（{{testerInfo.wrongNum}}）
      </el-radio-button>
      <el-radio-button label="3">
        未答（{{testerInfo.unAnswerNum}}）
      </el-radio-button>
      <el-radio-button label="4">
        全部试题（{{testerInfo.questionNum}}）
      </el-radio-button>
    </el-radio-group>
        <div class="watermark">
            <div class="question">
                <div class="question-main-content" v-if="questionList.length">
                    <div class="row" v-for="(item,index) in questionList" :key="item.id">
                        <div class="ques-title flex align-cen">
                            <span class="ques-number">{{index+1}}.</span>
                            <span class="ques-type">
                                {{$util.getTopicType(item.type)}}
                            </span>
                            <span v-html="item.title" style="max-width: 75%;margin:0 10px" :class="item.type == 9 ? 'clozeClass' : ''"></span>
                            <span class="ques-score">（{{item.questionScore}}分）</span>
                        </div>
                          <div class="question-option-list">
                            <ol v-if="item.type != 9 && item.type != 5">
                                <li v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                    <p v-html="sonitem.content"></p>
                                </li>
                            </ol>
                                    <div class="refAnswer"  v-if="item.type == 5" style="margin-left:-25px">
                              <div class="detailKeyWorld" v-if="item.rule">
                                  <div class="flex align-cen" style="font-size:16px;color:#999;padding:10px 0">
                                  <p>关键字：</p>
                                      <p v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                      {{sonitem.content}}<span v-if="sonIndex !=item.questionAnswerList.length-1">，</span>
                                  </p>
                                  </div>
                              </div>
                              <div class="detailKeyWorld" v-else style="font-size:16px;color:#999;padding:10px 0">关键字:无</div>
                          </div>
                                <div class="clzoe" v-if="item.type == 9">
                                <div class="clzoeItem" v-for="(sonitem,sonIndex) in item.questionAnswerList" :key="sonIndex">
                                <p class="cloze-op-p" style="margin-left:-25px">
                                    <strong> {{sonIndex + 1}}:</strong>
                                </p>
                                <ol >
                                    <li  v-for="(sonitem1,sonIndex1) in item.questionAnswerList[sonIndex].clozeList" :key="sonIndex1">
                                        <p v-html="sonitem1.content"></p>
                                    </li>
                                </ol>
                                </div>
                            </div>
                          </div>
                                              <div class="ques-answers">
                            <div class="test_result flex align-cen">
                                <div class="userAnswer">
                                    <div class="test_result_span_title">考生答案：</div>
                                    <strong :class="item.doRight == 1 ? 'true' : 'false'" v-if="item.isAnswer == '1'">
                                        {{item.answerContent}}
                                        <i :class="item.doRight == 1 ? 'icon-al-check' : 'icon-al-times'" v-if="radio != 5"></i>
                                    </strong>
                                    <span v-else>未作答</span>
                                </div>
                                <div class="rightAnswer" v-if="item.type != 7 && item.type != 9 && item.type != 5">
                                     <div class="test_result_span_title">正确答案：</div>
                                        <div class="dnl flex">
                                            <span v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                        <strong  v-if="sonitem.isRight == 1">
                                        {{Eng[sonIndex]}}
                                    </strong>
                                    </span>
                                    </div>
                                </div>
                                <div v-if="item.type == 5" class="rightAnswer" style="color:#009aff">
                                       <div class="test_result_span_title">参考答案：</div>
                                  <span v-html="item.refAnswer"></span>
                                </div>
                                 <div v-if="item.type == 7" class="rightAnswer">
                                    <div class="test_result_span_title">正确顺序：</div>
                                    <span v-for="(sonitem,sonIndex) in item.sortedIndexes">
                                        <span>
                                        {{Eng[sonitem]}}
                                    </span>
                                    </span>
                                </div>
                                  <div v-if="item.type == 9" class="rightAnswer">
                                     <div class="test_result_span_title">正确答案：</div>
                                    <span v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                                <span style="margin-right:20px">
                                                {{sonIndex + 1}}:
                                                <span v-for="(sonitem1,sonIndex1) in item.questionAnswerList[sonIndex].clozeList" :key="sonIndex1">
                                                    <span v-if="sonitem1.isRight == 1">{{Eng[sonIndex1]}}</span>
                                                </span>
                                                </span>
                                    </span>
                                </div>
                                <div class="score">
                                    <div class="test_result_span_title">分数：</div>
                                    <strong style="color: #36aafd">
                                       {{item.customerScore || 0}} / {{item.questionScore}}分
                                    </strong>
                                </div>
                            </div>
                        </div>
                          <div class="jx flex align-cen">
                            题目解析：<span v-html="item.analysis || '暂无解析'" style="max-width: 75%;line-height:30px"></span>
                         </div>
                    </div>
                </div>
                <div v-else>
                  <el-empty description="暂无数据"></el-empty>
                </div>
            </div>
        </div>
  </div>
        </el-tab-pane>
        <el-tab-pane label="后台监考" name="3">
            <div class="actions-list" style="padding:0 10px">
                <el-timeline>
                     <el-timeline-item
                    v-for="(activity, index) in resultLogList"
                    :key="index"
                    :type="'success'"
                    :color="'#36aafd'"
                    :size="'large'"
                    placement="top"
                    :timestamp="activity.createTime">
                    <el-card>
                    <h4>{{activity.operate}}</h4>
                    <p> ip:{{activity.ip}}</p>
                </el-card>
                  
                    </el-timeline-item>
                </el-timeline>
            </div>
        </el-tab-pane>
        </el-tabs>
                <div class="info-row flex align-cen">
         <span class="info-col-left flex align-cen"> 
            <i class="icon-al-share"></i>分享
         </span>
         <span class="info-col-right felx align-cen mft">
            <span class="pc-wc-share" @click="sharePaper">
                 <el-tooltip placement="left" class="item" effect="dark" content="查看分享海报" popper-class="silderMenu-tips"  >
                <i class="icon-al-qrcode"></i>
                 </el-tooltip>
            </span>
                
             <span class="pc-wc-share" @click="copyLink">
                <el-tooltip placement="left" class="item" effect="dark" content="复制链接" popper-class="silderMenu-tips"  >
                <i class="icon-al-link"></i>
                  </el-tooltip>
            </span>
         </span>
        </div>
      </el-dialog>
                  <el-dialog
  title="监控"
  :visible.sync="centerDialogVisible1"
  width="40%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass"
  v-if="centerDialogVisible1 && isActive == 0"
  >
      <div class="actions-list" style="padding:0 10px">
                <el-timeline>
                     <el-timeline-item
                    v-for="(activity, index) in resultLogList1"
                    :key="index"
                    :type="'success'"
                    :color="'#36aafd'"
                    :size="'large'"
                    placement="top"
                    :timestamp="activity.createTime">
                    <el-card>
                    <h4>{{activity.operate}}</h4>
                    <p> ip:{{activity.ip}}</p>
                </el-card>
                  
                    </el-timeline-item>
                </el-timeline>
            </div>
            </el-dialog>
                          <el-dialog
  title="分享成绩单"
  :visible.sync="centerDialogVisible3"
  width="440px"
  :append-to-body="true"
  center>
    <posterDraw :propImg="propImg" :propText="propText" :propQrcode="link" :dowloadImgName="dowloadImgName" ref="posterEmit"></posterDraw>
</el-dialog>
      </div>
</template>
<script>
import {getPaper,ResultList,monitor,missExamPage,rankList,resulttRanscript,resultMonitorLog,forceSubmit,deletResult} from "@/api/enterprise/index"  //获取试卷详情、考试记录分页、缺考、排行榜列表
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import exportExcel from '../../../utils/exportExcel.js' //导出数据公共方法
import mycomponents from "@/utils/compoments.js"
export default {
    name:'enExamLog',
    components:{
      paginaTion,
      posterDraw:mycomponents.components.posterDraw
    },
    data () {
        return {
           dowloadImgName:'成绩单',
          propData:{},
            propImg:'https://oss.yhkz.com/2024-05-25/%E6%88%91%E7%9A%84%E8%80%83%E8%AF%95%20(2)_20240525134806.jpg',
            propText:'',
            link:'',
          centerDialogVisible3:false,
                    searcradio:'',
            pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
          search:'',
          search1:'',
          search2:'',
          search3:'',
          centerDialogVisible1:false,
            rank:[],
            paperInfo:{},
            radio:'1',
            businessInfo:{},
            isSwitch:false,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            list:[], 
            list1:[],
            list2:[],
            multipleSelection:[],
            testerInfo:{},
            businessInfo:{},
            isActive:1,
              pageInfo:{},
            resultLogList:[],
            resultLogList1:[],
            Eng:['A','B','C','D','E','F','G','H','I','J'],
            resultQuestionVOList:[],
            questionList:[],
            radio:'1',
            activeName:'1',
            centerDialogVisible:false,
             start_time:'',
            end_time:''
        }
    },
    created() {
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.getPaperDetail()
        this.getResultList(1)
        this.getMonitor()
    },
    methods: {
          // 打开批卷
        getGradingPaper(data){
            this.$router.push({
            name: "enGradingPaper",
            query:{
                id:data.id,
                paperId:this.$route.query.paperId,
                redirect:'enExamLog',
                practiceMode:this.$route.query.practiceMode
            }
           })
        },
            reset(){
         this.search1=""
          this.search=""
          this.searcradio=""
          this.search3=""
          this.start_time=""
          this.end_time=""
          this.currentPage=1
          this.getResultList(this.isActive)
      },
        // 不限
      allradio(){
        this.searcradio = ''
        this.currentPage = 1
        this.getResultList(this.isActive)
      },
      // 筛选
      classSelect(){
        if(this.search3){
             this.start_time = this.search3[0]
            this.end_time = this.search3[1]
            }else{
              this.start_time = ""
              this.end_time = ""
            }
          this.currentPage = 1
          this.getResultList(this.isActive)
      },
      // 删除考试记录
      deletTopic(val){
        let chek = []
        if(!val.length){
          this.$util.Notifi('至少选择一项','error','fa-exclamation-circle')
        }else{
          val.forEach(t => {
            chek.push(t.id)
          });
         chek = chek.join(",")
         this.$confirm('您确认要删除该考试记录吗？一旦删除，将无法找回。若要使用统计分析功能，请勿删除考试记录，否则将会导致统计分析不准确。', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            deletResult({
              id:chek,
              businessId:this.businessInfo.id
              })
                .then(res => {
                if(res.code == 0){
                   this.$util.Notifi('删除成功','success','fa-check')
                 this.multipleSelection = []
                  if(this.$refs['multipleTable']){
                        this.$refs.multipleTable.clearSelection();
                    } 
                   this.getResultList(this.isActive,true)
                }else{
                   this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
                }
              })
              .catch(err => {
              })
        })
        }
      },
            // 强制交卷
        subqz(data){
             let bfb = Number(data.answerCount)/Number(data.questionCount) * 100
               this.$confirm(`我们建议只强制提交完成率为80%以上的试卷,当前完成率为${bfb}%，是否继续交卷？`, '温馨提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        forceSubmit({id:data.id}).then(res => {
                             this.$message.success('强制交卷成功'); 
                            this.getMonitor()
                             this.getResultList(0)
                            })
                        }).catch(() => {          
                        });
        },
          // 打开监控
        openTimline(data){
            this.centerDialogVisible1 = true
            resultMonitorLog({id:data.id}).then(res => {
              this.resultLogList1 = res.data
            })
        },
                 copyLink(){
     let _self = this
      this.$copyText(this.link).then(
        function(e) {
            _self.$message.success('复制成功')
        },
        function(e) {
         _self.$message.error('复制失败')
        }
      );
        },
        sharePaper(){
            this.centerDialogVisible3 = true
              this.$nextTick(() => {
                 this.$refs.posterEmit.handleChangeImg(this.propData) 
              })
           
        },
              // 获取成绩单
        getResulttRanscript(data){
            this.centerDialogVisible = true
            this.activeName = '1'
            this.radio = '1'
            this.resultQuestionVOList = []
            this.questionList = []
            resulttRanscript({id:data.id}).then(res => {
                 this.propData = data
                this.testerInfo = res.data
                this.resultQuestionVOList = res.data.resultQuestionVOList
                this.resultLogList = res.data.resultLogList
                this.propText =  `考生：${data.examiner}`
                this.dowloadImgName = data.examiner
                this.link = this.$config.prUrl + '#/myExam/transcriptExam?resultId=' + data.id + '&type=2'
                       this.resultQuestionVOList.forEach(k =>{
                if(k.type == 9){
                  k.questionAnswerList.forEach((t,index) =>{
                     let patternString = `{{${index + 1}}}`;
                     k.title = k.title.replace(patternString, '_______')
                  })
                }
                if(k.type == 7){
                  let indexedArray = k.questionAnswerList.map((item, index) => ({ item, index }));  
                   indexedArray.sort((a, b) => a.item.sort - b.item.sort);   
                    k.sortedIndexes = indexedArray.map(item => item.index); 
                }
              })
                this.getQuestionListCom(1)
            })
        },
              getQuestionListCom(type){
            this.questionList = []
          if(type == 1){
            for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='1' && this.resultQuestionVOList[key].doRight == '1'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 2){
             for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='1' && this.resultQuestionVOList[key].doRight == '0'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 3){
             for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='0'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 4){
                this.questionList = this.resultQuestionVOList
             }else if(type == 5){
             for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].doRight =='2' && this.resultQuestionVOList[key].isAnswer =='1'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
             }else{
                this.questionList = []
             }
        },
      // 随机显示字体颜色
      randomFun(){
         let Arr = ["#554a25","#266442","#aa7510","#b56676","#19e5e1","#ceadcc","#25ad1d","#07b287","#b9a3c9","#30f41a"];
            let n = Math.floor(Math.random() * Arr.length + 1)-1;
            return {'color' : Arr[n],'borderColor': Arr[n]}
      },
      // 排行榜显示不同状态
      getStatu(state,type){
        // type1 = 1 表示前三名图标
        const actionTypelanes = { 
          0:type==1 ? require('../../../assets/images/rankf.png') : '',
          1:type==1 ? require('../../../assets/images/ranks.png') : '',
          2:type==1 ? require('../../../assets/images/rankt.png') : ''
        }
         return actionTypelanes[state] || ''
      },
          // 获取考试监控基本信息
        getMonitor(){
            monitor({id:this.$route.query.paperId,businessId:this.businessInfo.id, practiceMode:this.$route.query.practiceMode})
            .then(res =>{
               this.pageInfo = res.data
            }) 
        },
         // 获取试卷详情
        getPaperDetail(){
            getPaper({id:this.$route.query.paperId},'get')
            .then(res =>{
              this.paperInfo = res.data
              this.radio = '1'
            })
            .catch(err =>{})
        },
        // 返回
        reback(){
            this.$router.push({
                name:'enScoreAnalysis',
                query:{
                    id:this.$route.query.paperId
                }
            })
        },
        getResultListType(type,isSwitch){
           this.multipleSelection = []
            if(this.$refs['multipleTable']){
                        this.$refs.multipleTable.clearSelection();
                    } 
            if(type ==0 || type ==1){
                       this.search1=""
          this.search=""
          this.searcradio=""
          this.search3=""
          this.start_time=""
          this.end_time=""
          this.currentPage=1
                this.getResultList(type,isSwitch)
            }else if(type == 2){
                this.getResultList1(type,isSwitch)
            }else if(type == 3){
               this.getResultList2(type,isSwitch)
            }else{}
        },
             emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
        if(this.isActive == 0 || this.isActive == 1){
            this.getResultList(this.isActive, false)
        }else if(this.isActive  == 2){
            this.getResultList1(this.isActive, false) 
        }else{
           this.getResultList2(this.isActive, false)
        }
      },
         //   获取考试记录
        getResultList(type,isSwitch){
            this.list = []
            this.isActive = type
            this.isSwitch = isSwitch
            if(isSwitch){
                this.currentPage = 1
                this.PageSize = 10
            }
            let params = {
                businessId:this.businessInfo.id,
                current: this.currentPage,
                size:this.PageSize,
                state:type,
                id:this.$route.query.paperId,
                practiceMode:this.$route.query.practiceMode,
                result:this.searcradio,
                examiner:this.search,
                examinerPhone:this.search1,
                startTimeStart:this.start_time,
                startTimeEnd:this.end_time
            }
            ResultList(params).then(res=>{
                this.list = res.data.records 
             this.totalCount = res.data.total || 0; 
            })
        },
        // 导出排行榜
          // 导出
      exportExcel(val){
        if(val.length !=0){
          let keyLisst = [] 
          for(let item in val){
             keyLisst.push( {
              '姓名':val[item].examiner, 
              '分数':val[item].userScore,
              '用时':this.$util.convertSecondsToMinutes(val[item].doTime,1), 
              '排名':Number(item) + 1,
              } ) 
             }
         exportExcel.exportExcel(keyLisst,`考试记录排行榜`)
        }
        else{
          this.$util.Notifi('暂无数据','error','fa-exclamation-circle')
        }
      },
      exportExcel1(val){
          if(val.length !=0){
          let keyLisst = [] 
          if(this.isActive == 1){
             for(let item in val){
             keyLisst.push( {
              '姓名':val[item].examiner, 
              '所属企业':val[item].businessName,
              '得分':val[item].userScore,
              '得分比':val[item].scoreRate + '%',
              '考试时间':val[item].startTime,
              '用时':this.$util.convertSecondsToMinutes(val[item].doTime,1), 
              '考试状态':'已考完'
              } ) 
             }
          }else{
             for(let item in val){
             keyLisst.push( {
              '姓名':val[item].examiner, 
              '所属企业':val[item].businessName,
              '答题进度':val[item].answerCount / val[item].questionCount,
              'IP':val[item].ip,
              '进入考试时间':val[item].startTime,
              '考试状态':'未考完'
              } ) 
             }
          }
         exportExcel.exportExcel(keyLisst,`考试记录`)
        }
        else{
          this.$util.Notifi('至少选择一项导出','error','fa-exclamation-circle')
        }
      },
            // 缺考
         getResultList1(type,isSwitch){
             this.isActive = type
            this.isSwitch = isSwitch
            this.list1 = []
            this.totalCount = 0
             if(isSwitch){
                this.currentPage = 1
                this.PageSize = 10
            }
             let params = {
                businessId:this.businessInfo.id,
                current: this.currentPage,
                size:this.PageSize,
                id:this.$route.query.paperId,
            }
            missExamPage(params).then(res=>{
                this.totalCount = res.data.total || 0;
                this.list1 = res.data.records || []
            })
         },
        //  排行榜
        getResultList2(type,isSwitch){
           this.isActive = type
            this.isSwitch = isSwitch
            this.list2 = []
             this.totalCount = 0
              if(isSwitch){
                this.currentPage = 1
                this.PageSize = 10
            }
            let params = {
                businessId:this.businessInfo.id,
                paperId:this.$route.query.paperId,
                practiceMode:this.$route.query.practiceMode,
                 current: this.currentPage,
                size:this.PageSize,
            }
             rankList(params).then(res=>{
                
                 this.list2 = res.data.records 
             this.totalCount = res.data.total || 0;
            })
        },
              getRowKeyOfTarget(row) {
            return row.id
            },
            // 表格选择
         handleSelectionChange(val) {
        this.multipleSelection = val;
      },
    },
}
</script>
<style lang="scss" scoped>
.print-tab-content{
    margin-top: 20px;
    .tester-info{
        text-align: center;
        .text{
            margin-bottom: 0px;
            font-size: 20px;
            color: #333;
        }
        .lastP{
            font-size: 14px;
            color: #999;
        }
        .sorceRow{
            margin: 20px  0 10px 0;
              .reult2{
                .reult2_pj{
                    font-size:13px;
                    color: #999;
                }
            }
            .exam-record-info{
                flex-grow: 1;
                .score-num{
                   color: #333;
                   font-size: 50px;
                   position: relative;
                   font-weight: bold;
                   span{
                    font-size: 14px;
                    
                   }
                //    .UserNum{
                //     position: absolute;
                //     top: 0; 
                //     right: 0;
                //     .pbot{
                //         font-size: 14px;
                //     }
                //    }
                }
            }
        }
    }
}
.watermark{
    .question{
        margin-top: 50px;
        .question-main-content{
            .row{
                .ques-title{
                    vertical-align: middle;
                    -webkit-margin-before: 0;
                    -webkit-margin-after: 0;
                    word-break: break-word; 
                   .ques-number,.ques-type{
                    color: #36aafd;
                   } 
                   .ques-score{
                    color: #aeaeae;
                   }
                }
                .ques-answers{
                    margin-top: 15px;
                    .test_result{
                        justify-content: space-between;
                        .userAnswer{
                            color: #666;
                            min-width: 100px;
                            .true{
                                color: green;
                                font-size: 16px;
                            }
                            .false{
                                color: red;
                                font-size: 16px;
                            }
                        }
                        .score{
                            min-width: 50px;
                            margin-left: 20px;
                        }
                        .dnl{
                            span{
                               color: #36aafd
                            }
                        }
                    }
                }
                .jx{
                    color: #999;
                        padding-top: 10px;
                }
            }
        }
    }
}
.rank-box{
  position: relative;
  width: 60%;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px!important;
  box-shadow: 0px 0px 10px 0px rgba(11, 34, 51, 0.05);
  padding: 10px 15px;
  .ranks-title{
    position: relative;
    height: 45px;
    color: rgba(16, 16, 16, 1);
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    text-align: center;
    .exams-tit{
      font-size: 21px;
    }
    .ranks-title-btn{
      background-color: #36aafd;
    color: white;
    border: 1px solid #36aafd;
    padding: 0px 20px;
    border-radius: 4px!important;
    cursor: pointer;
    position: absolute;
    right: 5px;
    top: 5px;
    }
  }
  .ranks-list{
        padding: 10px 26px 20px 26px;
    height: 100%;
    .rank{
      width: 90%;
      height: 80px;
      margin: 0 auto;
      .rank_num{
        color: rgba(16, 16, 16, 1);
    font-size: 14px;
    text-align: center;
    justify-content: center;
    line-height: 80px;
    min-width: 30px;
    .rank-img{
      width: 30px;
      height: 30px;
    border-radius: 100% !important;
    }
      }
      .strImg{
      width: 60px;
    height: 60px;
    line-height: 60px;
    border: 1px solid;
    border-radius: 100% !important;
    font-size: 24px;
    text-align: center;
    margin: 10px 0 10px 20px
      }
      .info{
        margin-left: 20px;
        .name{
          color: rgba(16, 16, 16, 1);
    font-size: 16px;
    margin-bottom: 0;
        }
        .time{
          color: rgba(153, 153, 153, 1);
          font-size: 14px;
        }
      }
      .count{
        margin-right: 20px;
    line-height: 80px;
    color: #f16f25;
    font-size: 16px;
      }
      }
  }
}
.tagbq{
    background-color: #ecf5ff;
    border-color: #d9ecff;
    color: #409eff;
    display: inline-block;
    height: 32px;
    padding: 0 10px;
    line-height: 30px;
    font-size: 12px;
    color: #409eff;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    box-sizing: border-box;
    white-space: nowrap;
    margin-right: 10px;
}
.publicViewClass{
    margin-bottom: 70px;
}
.blue,.yellwo{
    width: 18px;
    height: 18px;
    text-align: center;
    line-height: 18px;
    color: #fff;
    background: #89C4F4;
    border-radius: 50%;
    display: inline-block;
    font-size: 12px;
    margin-left: 8px;
}
.yellwo{
    background: #ff962a;
}
  .exam-title{
    position: relative;
    padding: 0 24px;
    height: 40px;
    line-height: 40px;
    background-color: #ffffff;
    border-bottom: solid 1px #e6e6e6;
    border-radius: 10px 10px 0 0;
    font-size: 20px;
    color: #333333;
    font-weight: 600;
    cursor: default;
    b{
      font-weight: bolder;
    }
    .title-extra{
      font-size: 14px;
      font-weight: normal;
      color: #999;
    }
    .public-de {
      color: #999;
      font-size: 14px;
      font-weight: normal;
      padding-left: 20px;
      cursor: pointer;
    }
  }
  .exam-content{
    padding-top: 20px;
    .tabbable-custom{
           .rdsdiv{
           height: 2px;
        background: #f7f8fa;
        margin-left: -16px;
        margin-top: 30px;
        width: calc(100% + 32px);
            }
    }
  }
  ::v-deep{
           .clozeClass{
    p{
        display: inline-block !important;
      }
  }
    .el-radio-group{
       .el-radio-button__inner{
        border: none;
        width: 120px;
        height: 40px;
        background-color: rgb(246, 246, 246);
        display: flex;
        align-items: center;
        justify-content: center;
       } 

     .el-radio-button__orig-radio:checked + .el-radio-button__inner{
     background-color: #36aafd;
     border-radius: 5px;
     }  
    }
  }
</style>